(function() {

  // Function to extract URL parameter value by name
  function getUrlParameter(name) {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    //return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    return results === null ? '' : decodeURIComponent(results[1]);
  }

  // Get the value of the 'registrationToken' parameter from the URL
  var registrationToken = getUrlParameter('registrationToken');

  var iframeUrl = 'https://mediterranea-site.nohup.host/user/recall?registrationToken=' + registrationToken;

  $('#user-recall-iframe').append("<iframe src="+ iframeUrl +" />");

})();